<template>
  <div :class="generatorMainSectionClass">
    <div :class="generatorTableSectionClass">

      <div class="row top-space">
        <ul class="nav nav-tabs">
          <li class="nav-item common-tab">
            <a :class="centralSuppliersTabClass" aria-current="page" @click="openSuppliersListStage('CENTRAL')">Centralne
              kartoteki dostawców</a>
          </li>
          <li class="nav-item common-tab">
            <a :class="localDrugstoresSuppliersTabClass" @click="openSuppliersListStage('LOCAL')">Dane dostawców z
              aptek</a>
          </li>

        </ul>
        <div class="row top-space">
          <div v-if="currentSuppliersContext === 'CENTRAL'" class="mb-3 windows-like-breadcrumb-card shadow-sm">
            <SupplierDataList :enableRowSelection="false"/>
          </div>
          <div v-else-if="currentSuppliersContext === 'LOCAL'" class="mb-3 windows-like-breadcrumb-card shadow-sm">
            <DrugstoresSuppliersLocalDataList :enableRowSelection="false"/>
          </div>

        </div>


      </div>
    </div>
  </div>

</template>


<script>
import SupplierDataList from "./SupplierDataList.vue";
import {log} from "@/state/pinia/log";
import DrugstoresSuppliersLocalDataList from "./DrugstoresSuppliersLocalDataList.vue";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {mapStores} from "pinia";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";



import {useLayoutStore} from "@/state/pinia";



export default {
  name: "SuppliersStage",
  props: {
    displayInBootstrapRow: {
      type: Boolean,
      default: () => false
    },

  },
  components: {
    DrugstoresSuppliersLocalDataList,
    SupplierDataList

  },
  data() {
    return {
      centralSuppliersTabClass: "nav-link active",
      localDrugstoresSuppliersTabClass: "nav-link",
      currentSuppliersContext: "CENTRAL",

    };
  },
  computed: {
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },
    layoutStore() {
      return useLayoutStore();
    },
    layout: {
      get() {
        return this.layoutStore.layoutType;
      },
      set(layout) {
        this.layoutStore.changeLayoutType(layout);
      }
    },
    generatorTableSectionClass() {
      if (this.layout === 'vertical' || this.displayInBootstrapRow) {
        return 'generator-table-container-vertical windows-like-breadcrumb-card shadow-sm scrollable-container';
      } else {
        return 'generator-table-container windows-like-breadcrumb-card shadow-sm scrollable-container';
      }
    },
    generatorMainSectionClass() {
      if (this.layout === 'vertical' || this.displayInBootstrapRow) {
        return 'row package-orders-generator-site';
      } else {
        return 'package-orders-generator-site';
      }
    },

  },
  methods: {

    openSuppliersListStage(openedPaymentType) {
      this.currentSuppliersContext = openedPaymentType;
      if (openedPaymentType === "CENTRAL") {
        this.centralSuppliersTabClass = "nav-link active";
        this.localDrugstoresSuppliersTabClass = "nav-link";
      } else if (openedPaymentType === "LOCAL") {
        this.centralSuppliersTabClass = "nav-link";
        this.localDrugstoresSuppliersTabClass = "nav-link active";

      }

    }

  },
  watch: {},
  mounted() {
    this.commonModule.setHorizontalNavbarTitle(`<i class="bx bx-home-circle me-1"></i> Dostawcy`)
  },
  created() {
    log.log("trigger refresh token")
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();

    });
  },
};
</script>

<style scoped>
.top-space {
  margin-top: 20px;
}

.common-tab {
  cursor: pointer;
}



.package-orders-generator-site {

}
</style>
